import React, { useState } from "react";
import TableHeader from "../../components/Common/TableHeader";
import Dropdown from "../../components/Searchbar/Dropdown";

const SamplePage = () => {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");

  const [selectedRange, setSelectedRange] = useState(""); // Used for dropdown-based date ranges

  const handleSearch = () => {
    //console.log("Searching:", {
    //   search,
    //   status,
    //   selectedRange,
    // });
  };
  const error = "editing";
  return (
    <div className="p-4 sm:p-6 md:p-[30px] bg-diagonal-sky min-h-screen">
      {/* Notification Center */}
      <div className="mb-[30px]">
        <h1 className="mb-5"> Notofication Center</h1>
        <TableHeader
          searchValue={search}
          onSearchChange={setSearch}
          onSearchSubmit={handleSearch}
          searchPlaceholder="Search by landlord name or bank reference"
          buttons={[
            {
              label: "SEARCH",
              onClick: handleSearch,
              variant: "main",
              // className:
              //   "bg-[#873FE2] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[102px] ",
            },
          ]}
          isAutoRemainder={true}
          searchWrapperClass="w-full [@media(min-width:585px)]:w-auto"
          containerClass="md:grid md:grid-cols-3 flex flex-wrap sm:flex-nowrap"
          buttonWrapperClass="w-auto"
        />
      </div>

      {/* Portfolio Performance Report */}
      <div className="mb-[30px]">
        <h1 className="my-5">
          Portfolio Performance Report | Occupancy Insights | Payment
          Distribution Report{" "}
        </h1>
        <TableHeader
          searchValue={search}
          //   onSearchChange={setSearch}
          onSearchSubmit={handleSearch}
          //   searchPlaceholder="Search by landlord name or bank reference"
          filters={[
            {
              name: "Filter by Property",
              value: type,
              onChange: setType,
              options: [
                { label: "All", value: "" },
                { label: "Option 1", value: "1" },
                { label: "Option 2", value: "2" },
                { label: "Option 3", value: "3" },
              ],
            },
          ]}
          dateRangeFilter={{
            value: selectedRange,
            onChange: setSelectedRange,
            options: [
              { label: "Today", value: "today" },
              { label: "This Week", value: "this_week" },
              { label: "This Month", value: "this_month" },
              { label: "Last Month", value: "last_month" },
            ],
          }}
          buttons={[
            {
              label: "SEARCH",
              onClick: handleSearch,
              variant: "secondary",
              className:
                "bg-[#873FE2B0] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[102px] ",
            },
          ]}
          // containerClass=" grid grid-cols-1 sm:flex w-full p-3 sm:p-4 md:p-6 lg:p-[30px] gap-3 md:gap-3 lg:gap-[15px]"
          // filterDropdownClass="w-full md:max-w-[260px] flex flex-grow"
          // searchInputClass="text-gray-700 h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] w-full [@media(min-width:1440px)]:w-[388px]"
          datePickerClass="sm:max-w-[210px] md:max-w-[260px] flex flex-grow w-full"
          buttonWrapperClass="sm:mr-0 mx-auto xs:w-auto w-full"
          containerClass="md:grid lg:flex md:grid-cols-3 flex flex-wrap sm:flex-nowrap"
          dropdownWrapperClass="sm:max-w-[210px] md:max-w-[260px] flex flex-grow w-full"
        />
      </div>

      {/* Payment History */}
      <div className="mb-[30px]">
        <h1 className="my-5"> Payment History </h1>
        <TableHeader
          searchValue={search}
          onSearchChange={setSearch}
          onSearchSubmit={handleSearch}
          searchPlaceholder="Tenant name / Unit ID"
          filters={[
            {
              name: "Filter by Units",
              value: type,
              onChange: setType,
              options: [
                { label: "All", value: "All" },
                { label: "Unit 1", value: "Unit 1" },
                { label: "Unit 2", value: "Unit 2" },
                { label: "Unit 3", value: "Unit 3" },
              ],
            },
          ]}
          dateRangeFilter={{
            value: selectedRange,
            onChange: setSelectedRange,
            options: [
              { label: "Today", value: "today" },
              { label: "This Week", value: "this_week" },
              { label: "This Month", value: "this_month" },
              { label: "Last Month", value: "last_month" },
            ],
          }}
          buttons={[
            {
              label: "SEARCH",
              onClick: handleSearch,
              variant: "secondary",
              // className:
              //   "bg-[#873FE2] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[102px] ",
            },
            {
              label: "DOWNLOAD",
              onClick: handleSearch,
              variant: "main",
              className:
                "bg-[#873FE2] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[120px]",
            },
          ]}
          // containerClass="flex-wrap md:flex-nowrap gap-3"
          containerClass="md:grid md:grid-cols-4 lg:grid-cols-4 flex flex-wrap sm:flex-nowrap"
          datePickerClass="md:w-auto flex w-full"
          buttonWrapperClass="md:mr-0 w-full xs:mx-auto xs:w-auto"
          // dropdownWrapperClass="sm:max-w-[210px] lg:w-[180px] xl:max-w-[260px] flex flex-grow w-full"
          // searchWrapperClass="w-full md:w-auto"
          // searchWrapperClass="w-full sm:w-full md:w-full lg:w-[230px] xl:w-[280px]"
          // searchWrapperClass="w-full max-w-full sm:w-0 [@media(min-width:717px)]:w-auto [@media(min-width:1171px)]:w-auto lg:w-[100px]"
          // containerClass=" grid grid-cols-1 sm:flex w-full p-3 sm:p-4 md:p-6 lg:p-[30px] gap-3 md:gap-3 lg:gap-[15px] shadow-[0px_4px_4px_0px_#0000000F]"
          // filterDropdownClass="text-sm w-full md:flex-grow [@media(min-width:1440px)]:w-[240px]"
          // searchInputClass="text-gray-700 h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] w-full max-w-auto md:w-auto"
          // datePickerClass="gap-2"
          // buttonClass="bg-[#6B46C1]"
        />
      </div>
      <div className="mb-[30px]">
        <Dropdown />
      </div>

      {/* Manage Properties */}
      <div className="mb-[30px]">
        <h1 className="my-5"> Manage Properties </h1>
        <TableHeader
          searchValue={search}
          onSearchChange={setSearch}
          onSearchSubmit={handleSearch}
          searchPlaceholder="Tenant name / Unit ID"
          buttons={[
            {
              label: "SEARCH",
              onClick: handleSearch,
              variant: "secondary",
              // className:
              //   "bg-[#873FE2] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[102px] ",
            },
            ...(error === "e-diting"
              ? [
                  {
                    label: "Cancel",
                    onClick: handleSearch,
                  },
                ]
              : []),
            // className:
            //   "bg-[#873FE2] text-white h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] px-3 rounded-[3.77px] uppercase w-[102px] ",
          ]}
          isAddProperty={true}
          searchWrapperClass="w-full [@media(min-width:585px)]:w-auto"
          containerClass="md:grid md:grid-cols-3 flex flex-wrap sm:flex-nowrap"
          buttonWrapperClass="w-full xs:w-auto"
          // buttonWrapperClass="md:mr-0 w-full xs:mx-auto bg-black xs:w-auto"

          //   containerClass="grid grid-cols-1 xs:flex w-full p-3 sm:p-4 md:p-6 lg:p-[30px] gap-3 md:gap-3 lg:gap-[15px] shadow-[0px_4px_4px_0px_#0000000F]"
          // filterDropdownClass="text-sm w-full md:w-full [@media(min-width:1440px)]:w-[240px]"
          // searchInputClass="text-gray-700 h-[36px] sm:h-[39px] md:h-[42px] lg:h-[45px] w-full [@media(min-width:1440px)]:w-[388px]"
          // datePickerClass="gap-2"
          // buttonClass=""
        />
      </div>
    </div>
  );
};

export default SamplePage;
